<template>
  <div class="layout srmlayout">
    <Layout style="height:100%">
      <Sider ref="sideMenu" hide-trigger collapsible :collapsed-width="40" v-model="isCollapsed" width="150vh" :style="{position: 'fixed', width: '150vh', height: '100vh', left: 0, overflow: 'auto', zIndex: 999}">
        <core-sidebar :collapse="isCollapsed"></core-sidebar>
      </Sider>
      <Layout :style="{minHeight: '100vh', marginLeft: isCollapsed ? '40px' : '150px'}">
        <core-header :collapse="isCollapsed" @on-toggle-click="handleToggleClick" @on-theme-change="handleThemeChange"></core-header>
        <tags-nav/>
        <Paper>
         <notice-dialog></notice-dialog>   
         <keep-alive :include="tags.map(item => item.name)">
            <router-view></router-view>
          </keep-alive>
        </Paper>
      </Layout>
    </Layout>
  </div>
</template>
<style scoped lang ='less'>
.layout {
  background: #f5f7f9;
  position: relative;
  overflow-x: hidden;
  height: 100%;
}
</style>
<script>
import CoreHeader from '@/components/core/themes/default/CoreHeader.vue';
import CoreSidebar from '@/components/core/themes/default/CoreSidebar.vue';
import Paper from '@/components/core/paper/Paper.vue';
import tagsNav from '@/components/core/tags_nav';
import noticeDialog from '@/modules/globalprotal//views/sys/noticeDialog';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isCollapsed: false,
      theme: 'default',
    };
  },
  computed: {
    ...mapGetters(['tags']),
    rotateIcon() {
      return ['menu-icon', this.isCollapsed ? 'rotate-icon' : ''];
    },
    menuitemClasses() {
      return ['menu-item', this.isCollapsed ? 'collapsed-menu' : ''];
    },
  },
  methods: {
    handleToggleClick() {
      this.$refs.sideMenu.toggleCollapse();
    },
    handleThemeChange(theme) {
      this.theme = theme;
    },
  },
  components: {
    CoreHeader,
    CoreSidebar,
    Paper,
    tagsNav,
    noticeDialog
  },
};
</script>
